import React, { FC } from 'react';

import { Grid } from '@material-ui/core';

import { IClubInvitation } from '../../../../store/clubInvitations/store';

import { ClubPendingInvitationsHeaderStyled } from './ClubPendingInvitations.Styles';
import ClubPendingInvitationsRow from './ClubPendingInvitationsRow';

interface IProps {
  invitations: IClubInvitation[];
}

const ClubPendingInvitations: FC<IProps> = props => {
  const { invitations } = props;

  return (
    <>
      <ClubPendingInvitationsHeaderStyled container={true}>
        <Grid className="grid-item" item={true} xs={6}>
          INVITED PLAYER EMAIL
        </Grid>

        <Grid className="grid-item" item={true} xs={2}>
          DATE INVITED
        </Grid>

        <Grid className="grid-item" item={true} xs={2}>
          CODE
        </Grid>

        <Grid className="grid-item" item={true} xs={2}>
          LINK
        </Grid>
      </ClubPendingInvitationsHeaderStyled>

      {invitations.map(invitation => (
        <ClubPendingInvitationsRow invitation={invitation} />
      ))}
    </>
  );
};

export default ClubPendingInvitations;
